import { useEffect, useRef, useState } from 'react'
import {
  AccountEntitySearchType,
  EntityEventType,
  PersonEntitySearchType,
  TaskDropdownSectionProps,
  TaskPayload,
} from '../../types/workflow.types'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { EntityLayout, LayoutData } from '../../types/layout.types'
import {
  addToaster,
  DataType,
  DataTypeStore,
  DropdownType,
  fetchTaskEntititesDropdownOptionsApi,
  getAllLayoutApi,
  getEntityDataByEntityNameApiForFilter,
  getLayoutByEntityIdAndTypeApi,
  hideLoader,
  LayoutResponseType,
  OrganizationOptions,
  saveTaskDataApi,
  showLoader,
  TASK_TYPE_IDS,
  WORKFLOW_UI_IDENTIFIER,
  WorkflowInstanceTaskType,
} from '@app-store'
import {
  LAYOUT_TYPE_NAMESPACE,
  NAMESPACES,
  WORKFLOW_OUTCOMES,
  WORKFLOW_STATUS,
} from '../../utils/constants'
import {
  addEntityData,
  editEntityData,
  getEntityData,
  getEntityDataByIdEmbedded,
} from '../../apis/entityData.api'
import {
  Accordion,
  ControlledDropDown,
  CustomButton,
  FormInput,
  Modal,
  MODE_CONSTANTS,
  PaginatedControlledDropDown,
  SelectDropDown,
  SvgAdd,
  SvgPipe,
  SvgSearchIcon,
  SvgVerticalSplitter,
  SvgViewBlue,
  Tooltip,
} from '@ui-kit'
import { hasPermission, isSuperAdmin } from '../../utils/permission'
import { TOASTER_NAMESPACE } from '../../constants/addEditPage.strings'
import { FieldErrors, FieldValues } from 'react-hook-form'
import { v4 as uuid } from 'uuid'
import {
  DefaultFormFooter,
  FormHeader,
} from '../../pages/AddEditViewRecord.page'
import { RECORD_STATUS } from '../../constants/form.constants'
import { noop, uniqueId } from 'lodash'
import FormRenderer from '../FormRenderer'
import {
  hasSensitiveDataPermission,
  permissionObject,
} from '../../utils/helperFunctions'
import SearchLayout from '../../pages/call-interaction/SearchLayout'
import { ORGANIZATION_ENTITY } from '../../pages/intake-ques/IntakeQueReview'
import { APPLICATION_PREFERENCES_STRINGS } from '../../utils/strings'
import { AddDataModal } from '../MultiLookupRowRender'
import { AdvancedSearchInfo } from '../../pages/call-interaction/RequestorSearchForm'
import { PERSON_TYPE_ENTITIES } from '../../pages/call-interaction/CreateInteraction'
import { EntityDataProps } from '../../types/intakeQueue.types'
import { PERSON_RECORD_KEYS } from '../../constants/intakeQue.constants'
import { validatePhoneNumberAndAddress } from '../../utils/form.utils'

const TaskManagementDropdownSection: React.FC<TaskDropdownSectionProps> = ({
  task,
  setValue,
  control,
  errors,
  register,
  isTaskCompleted,
  watch,
  reFetch,
}) => {
  const isAccountDisabled =
    task?.task_template?.id &&
    Number(task?.task_template?.id) === TASK_TYPE_IDS.MANUAL_TEXT_OUTBOUND

  const dispatch = useAppDispatch()
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )
  const caseData = useAppSelector(
    (state: RootState) => state.workflowData?.caseData
  )
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const hasPersonOptionsInitialized = useRef<boolean>(false)
  const hasAccountOptionsInitialized = useRef<boolean>(false)
  const [selectedEntityType, setSelectedEntityType] = useState<{
    id: number | null
    name: string
  } | null>(null)
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [defaultPersonOption, setDefaultPersonOption] = useState<
    { label: string; value: string } | undefined
  >()
  const [defaultAccountOption, setDefaultAccountOption] = useState<
    { label: string; value: string } | undefined
  >()
  const [defaultEditLayout, setDefaultEditLayout] =
    useState<EntityLayout | null>(null)
  const [defaultViewLayout, setDefaultViewLayout] =
    useState<EntityLayout | null>(null)
  const [json, setJSON] = useState<EntityLayout[] | null>(null)
  const [isEditLayoutShown, setIsEditLayoutShown] = useState<boolean>(false)
  const [selectedEntityId, setSelectedEntityId] = useState<string | null>(null)
  const [personOptionsCurrentPage, setPersonOptionsCurrentPage] =
    useState<number>(0)
  const [personOptionsSize, setPersonOptionsSize] = useState<number>(100)
  const [accountOptionsCurrentPage, setAccountOptionsCurrentPage] =
    useState<number>(0)
  const [accountOptionsSize, setAccountOptionsSize] = useState<number>(100)
  const [searchPersonOption, setSearchPersonOption] = useState<
    EntityEventType[]
  >([])
  const [searchAccountOption, setSearchAccountOption] = useState<
    EntityEventType[]
  >([])
  const [personRecordId, setPersonRecordId] = useState<number | null>(null)
  const [selectedPersonEntityType, setSelectedPersonEntityType] = useState<
    string | null
  >(null)
  const [accountRecordId, setAccountRecordId] = useState<number | null>(null)
  const [selectedAccountEntityType, setSelectedAccountEntityType] = useState<
    string | null
  >(null)
  const [personUpdateKey, setPersonUpdateKey] = useState(0)
  const [accountUpdateKey, setAccountUpdateKey] = useState(0)
  const [selectedEntityDropdown, setSelectedEntityDropdown] =
    useState<string>('')
  const [entityData, setEntityData] = useState<DataType>()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const [editLayout, setEditLayout] = useState<LayoutResponseType>()
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [triggerSearch, setTriggerSearch] = useState<boolean>(false)
  const [editRecordData, setEditRecordData] = useState<FieldValues>()
  const [entityTypeAndId, setEntityTypeAndId] = useState({
    entityType: '',
    entityId: 0,
    label: '',
  })
  const [entityDataInner, setEntityDataInner] = useState<
    EntityDataProps | undefined
  >(undefined)
  const [isAdvancedSearch, setIsAdvancedSearch] = useState<boolean>(false)
  const [entityOptions, setEntityOptions] = useState<DropdownType<string>[]>([])

  const [viewEntityRecord, setViewEntityRecord] = useState<
    DataTypeStore | undefined
  >()
  const [isViewClicked, setIsViewClicked] = useState<boolean>(false)
  const [editEntityRecord, setEditEntityRecord] = useState<boolean | undefined>(
    false
  )
  const [addEntityRecord, setAddEntityRecord] = useState<boolean | undefined>(
    false
  )
  const [advancedFiltersData, setAdvancedFiltersData] =
    useState<AdvancedSearchInfo>()

  const Outcome_Options = [
    {
      label: WORKFLOW_OUTCOMES.SUCCESSFUL,
      value: WORKFLOW_OUTCOMES.SUCCESSFUL,
    },
    {
      label: WORKFLOW_OUTCOMES.UNSUCCESSFUL,
      value: WORKFLOW_OUTCOMES.UNSUCCESSFUL,
    },
    {
      label: WORKFLOW_OUTCOMES.LEFT_VOICEMAIL,
      value: WORKFLOW_OUTCOMES.LEFT_VOICEMAIL,
    },
    {
      label: WORKFLOW_OUTCOMES.UNABLE_TO_LEAVE_VOICEMAIL,
      value: WORKFLOW_OUTCOMES.UNABLE_TO_LEAVE_VOICEMAIL,
    },
    { label: WORKFLOW_OUTCOMES.HANG_UP, value: WORKFLOW_OUTCOMES.HANG_UP },
  ]

  const Fax_Outcome_Options = [
    {
      label: WORKFLOW_OUTCOMES.TRANSMISSION_SUCCESSFUL,
      value: WORKFLOW_OUTCOMES.TRANSMISSION_SUCCESSFUL,
    },
    {
      label: WORKFLOW_OUTCOMES.TRANSMISSION_IN_PROGRESS,
      value: WORKFLOW_OUTCOMES.TRANSMISSION_IN_PROGRESS,
    },
    {
      label: WORKFLOW_OUTCOMES.TRANSMISSION_FAILED,
      value: WORKFLOW_OUTCOMES.TRANSMISSION_FAILED,
    },
  ]

  const Sms_Outcone_Options = [
    {
      label: WORKFLOW_OUTCOMES.SUCCESSFUL,
      value: WORKFLOW_OUTCOMES.SUCCESSFUL_KEY,
    },
    {
      label: WORKFLOW_OUTCOMES.FAILED_LABEL,
      value: WORKFLOW_OUTCOMES.FAILED_KEY,
    },
    {
      label: WORKFLOW_OUTCOMES.IN_PROGRESS_LABEL,
      value: WORKFLOW_OUTCOMES.IN_PROGRESS_KEY,
    },
    {
      label: WORKFLOW_OUTCOMES.IN_PROGRESS_LABEL,
      value: WORKFLOW_OUTCOMES.TRANSMISSION_IN_PROGRESS_LABEL,
    },
  ]
  const normalize = (str: string) => str?.toLowerCase().replace(/[\s-_]/g, '')
  const handleEntityChange = async (e: DropdownType<unknown, string>) => {
    setEntityTypeAndId?.({
      entityId: Number(e.value),
      entityType: e.label?.toLowerCase(),
      label: e?.label,
    })

    setEntityDataInner({
      label: e.label,
      value: e.value,
    })
  }
  const isFaxOutboundTask = normalize(
    task?.task_template?.name || ''
  )?.includes('faxoutbound')

  const isTextOutboundTask = normalize(
    task?.task_template?.name || ''
  )?.includes('textoutbound')

  const outcomeOptions = isFaxOutboundTask
    ? Fax_Outcome_Options
    : isTextOutboundTask
    ? Sms_Outcone_Options
    : Outcome_Options

  const handleRecordTypeChange = async (e: DropdownType<unknown, string>) => {
    if (e.value === 'person') {
      setEntityOptions(PERSON_TYPE_ENTITIES)
      setEntityData?.(undefined)
    }
  }
  const fetchPersonOptions = async (
    page: number,
    limit: number,
    value?: string,
    id?: number
  ) => {
    try {
      let payload
      if (value) {
        payload = {
          entityType: NAMESPACES.PERSON.toLowerCase(),
          page: page,
          size: limit,
          searchValue: value,
          ...(id && { id }),
        }
      } else {
        payload = {
          entityType: NAMESPACES.PERSON.toLowerCase(),
          page: page,
          size: limit,
        }
      }
      const response = await fetchTaskEntititesDropdownOptionsApi(payload)
      const dataResponse = response?.data?.content
      if (dataResponse) {
        const dropdownResponse: EntityEventType[] =
          response?.data?.content?.map((person: PersonEntitySearchType) => ({
            label: person?.name,
            value: person?.id,
            recordId: person?.record_id,
            entityType: person?.entity_type,
            tooltip: person?.record_key,
          })) ?? []

        setSearchPersonOption((prevOptions) => {
          return [...(page === 0 ? [] : prevOptions ?? []), ...dropdownResponse]
        })

        setPersonOptionsCurrentPage(page)
        setPersonOptionsSize(limit)
        return dataResponse
      }
    } catch (error) {
      console.error(error)
    }
  }
  const fetchAccountOptions = async (
    page: number,
    limit: number,
    value?: string,
    id?: number
  ) => {
    try {
      let payload
      if (value) {
        payload = {
          entityType: NAMESPACES.ACCOUNT.toLowerCase(),
          page: page,
          size: limit,
          searchValue: value,
          ...(id && { id }),
        }
      } else {
        payload = {
          entityType: NAMESPACES.ACCOUNT.toLowerCase(),
          page: page,
          size: limit,
        }
      }
      const response = await fetchTaskEntititesDropdownOptionsApi(payload)
      const dataResponse = response?.data?.content
      if (dataResponse) {
        const dropdownResponse: EntityEventType[] =
          response?.data?.content?.map((account: AccountEntitySearchType) => ({
            label: account?.organization_name,
            value: account?.id,
            recordId: account?.record_id,
            entityType: account?.organization_type,
          })) ?? []

        setSearchAccountOption((prevOptions) => {
          return [...(page === 0 ? [] : prevOptions ?? []), ...dropdownResponse]
        })

        setAccountOptionsCurrentPage(page)
        setAccountOptionsSize(limit)
        return dataResponse
      }
    } catch (error) {
      console.error(error)
    }
  }
  const fetchViewLayoutByEntityName = async (entityName: string) => {
    try {
      dispatch(showLoader())
      const entityId =
        workflowDefinition?.global_variables?.entities?.[entityName]?.entity_id
      setSelectedEntityId(entityId ?? '')
      const response = await getAllLayoutApi({ entityId: entityId })
      if (response?.status === 200) {
        const defaultEditModeLayout = response?.data?.content?.find(
          (item: EntityLayout) =>
            item?.type === NAMESPACES.EDIT_MODE && item?.default_value === true
        )
        const defaultViewModeLayout = response?.data?.content?.find(
          (item: EntityLayout) =>
            item?.type === NAMESPACES.VIEW_MODE && item?.default_value === true
        )
        if (defaultEditModeLayout) setDefaultEditLayout(defaultEditModeLayout)
        if (defaultViewModeLayout) setDefaultViewLayout(defaultViewModeLayout)
      }
    } catch (err) {
      dispatch(hideLoader())
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchEntityData = async (isEdit: boolean) => {
    let data: EntityLayout | undefined = undefined
    if (isEdit) data = defaultEditLayout as EntityLayout
    else data = defaultViewLayout as EntityLayout
    if (!data) {
      return
    }
    try {
      const entity_data = await getEntityData(
        data?.entity_name,
        data?.entity_id,
        data?.id,
        selectedEntityDropdown === NAMESPACES.PERSON.toLowerCase()
          ? Number(personRecordId)
          : Number(accountRecordId)
      )
      setEntityData(entity_data?.data)
    } catch (err) {
      console.error(err)
    }
  }
  const renderPersonDropdownIcon = (
    disabled: boolean,
    closeOptions: () => void,
    selectedOption?: { label: string; value: string }
  ): JSX.Element => {
    const isPersonSelected = selectedOption?.value?.toString().length ?? 0
    const handleViewClick = (e: React.MouseEvent | React.KeyboardEvent) => {
      e.preventDefault()
      e.stopPropagation()
      setIsOpenModal(true)
      setSelectedEntityDropdown(NAMESPACES.PERSON.toLowerCase())
      fetchViewLayoutByEntityName(selectedPersonEntityType ?? '')
      if (isPersonSelected) {
        closeOptions()
      }
    }
    const handleAddClick = (e: React.MouseEvent | React.KeyboardEvent) => {
      e.preventDefault()
      if (isPersonSelected) {
        closeOptions()
      }
    }

    return (
      <div className={`flex items-center ${!disabled ? '-m-1 pr-1' : 'pl-1'}`}>
        {!isPersonSelected ? (
          <>
            <SvgPipe height="12" strokeWidth="3" />
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault()
                closeOptions()
                e.stopPropagation()
                setIsAdvancedSearch(!isAdvancedSearch)
                handleRecordTypeChange({ value: 'person', label: 'Person' })
              }}
              onKeyDown={(e) => e.key === 'Enter' && handleAddClick(e)}
              aria-label="Search"
              disabled={disabled}
              className="mr-1 ml-1"
            >
              <SvgSearchIcon color="#0A6FCD" />
            </button>
          </>
        ) : (
          <>
            <SvgPipe height="12" strokeWidth="3" />
            <button
              type="button"
              onClick={handleViewClick}
              onKeyDown={(e) => e.key === 'Enter' && handleViewClick(e)}
              aria-label="Edit"
              className="ml-1"
            >
              <SvgViewBlue />
            </button>
          </>
        )}
      </div>
    )
  }
  const renderAccountDropdownIcon = (
    disabled: boolean,
    closeOptions: () => void,
    selectedOption?: { label: string; value: string }
  ): JSX.Element => {
    const isAccountSelected = selectedOption?.value?.toString().length ?? 0
    const handleViewClick = (e: React.MouseEvent | React.KeyboardEvent) => {
      e.preventDefault()
      e.stopPropagation()
      setIsOpenModal(true)
      setSelectedEntityDropdown(NAMESPACES.ACCOUNT.toLowerCase())
      fetchViewLayoutByEntityName(selectedAccountEntityType ?? '')
      if (isAccountSelected) {
        closeOptions()
      }
    }
    const handleAddClick = (e: React.MouseEvent | React.KeyboardEvent) => {
      e.preventDefault()
      if (isAccountSelected) {
        closeOptions()
      }
    }

    return (
      <div className={`flex items-center ${!disabled ? '-m-1 pr-1' : 'pl-1'}`}>
        {!isAccountSelected ? (
          <>
            <SvgPipe height="12" strokeWidth="3" />
            <button
              type="button"
              onClick={handleAddClick}
              onKeyDown={(e) => e.key === 'Enter' && handleAddClick(e)}
              aria-label="Add"
              disabled={disabled}
              className="-mr-1"
            >
              <SvgAdd color="#0A6FCD" />
            </button>
          </>
        ) : (
          <>
            <SvgPipe height="12" strokeWidth="3" />
            <button
              type="button"
              onClick={handleViewClick}
              onKeyDown={(e) => e.key === 'Enter' && handleViewClick(e)}
              aria-label="Edit"
              className="ml-1"
            >
              <SvgViewBlue />
            </button>
          </>
        )}
      </div>
    )
  }

  const getEntityName = (entityType: string) => {
    switch (entityType) {
      case NAMESPACES.PATIENT_KEY:
      case NAMESPACES.PROVIDER_KEY:
      case NAMESPACES.CONTACT_KEY:
      case NAMESPACES.PAYER_KEY:
      case NAMESPACES.ORGANIZATION_KEY:
        return `${entityType.toLowerCase()}s`
      case NAMESPACES.PHARMACY_KEY:
      case NAMESPACES.FACILITY_KEY:
        return `${entityType.toLowerCase().slice(0, -1)}ies`
      default:
        return entityType.toLowerCase()
    }
  }

  const handleDropdownChange =
    (key: string) =>
    async (selectedOption: { value: string; label: string }) => {
      const payload: TaskPayload = {
        id: Number(task?.id),
      }

      if (key === NAMESPACES.OUTCOME.toLowerCase()) {
        payload.outcome = selectedOption?.label
        try {
          await saveTaskDataApi(
            task?.id as string,
            payload,
            caseData?.programs?.id?.toString(),
            caseData?.services?.id?.toString()
          )
        } catch (error) {
          console.error(error)
        }
      } else if (key === NAMESPACES.ENTITY_TYPE_KEY) {
        const entityTypeId = Number(selectedOption?.value)
        setSelectedEntityType({ id: entityTypeId, name: selectedOption?.label })
      } else if (key === NAMESPACES.ENTITY_KEY) {
        if (selectedEntityType && selectedEntityType.id !== null) {
          payload.entity_type = { id: selectedEntityType?.id }
          payload.entity = { id: Number(selectedOption?.value) }
          try {
            await saveTaskDataApi(
              task?.id as string,
              payload,
              caseData?.programs?.id?.toString(),
              caseData?.services?.id?.toString()
            )
          } catch (error) {
            console.error(error)
          }
        }
      }
    }

  const handleClose = () => {
    setIsOpenModal(false)
    setJSON(null)
    setDefaultEditLayout(null)
    setDefaultViewLayout(null)
    setIsEditLayoutShown(false)
    setSelectedEntityId(null)
    setEntityData(undefined)
  }
  const handleCatch = () => {
    if (!hasPermission(MODE_CONSTANTS.EDIT, selectedEntityId ?? '')) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.PERMISSION_DENIED,
          type: 'error',
          id: uuid(),
        })
      )
    } else {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_EDIT_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
    }
  }
  const save = async (values: FieldValues, embedded: string[]) => {
    if (!json) {
      return
    }
    if (!entityData) {
      console.error(NAMESPACES?.NO_ENTITY_DATA_AVAILABLE_FOR_EDITING)
      return
    }
    if (!entityData?.id) {
      console.error(NAMESPACES?.NO_ID_PROVIDED_FOR_EDITING)
      return
    }

    const editValues = values
    try {
      const res = await editEntityData(
        json?.[0].entity_name,
        json?.[0].entity_id,
        json?.[0].id,
        editValues,
        entityData?.id as number,
        embedded
      )
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.EDIT_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
      const { keyValue, type } = getRecordKeyAndEntityTypeByEntity(
        json?.[0].entity_name ?? ''
      )
      if (!keyValue || !res?.data) return
      const resVal = await getEntityDataByIdEmbedded(
        json?.[0].entity_name ?? '',
        Number(json?.[0].entity_id),
        [keyValue],
        res.data.id
      )
      if (!resVal?.data) return

      const response = await getEntityDataByEntityNameApiForFilter({
        payload: requestorPayload(
          resVal.data,
          keyValue,
          type === 'organization'
        ),
      })

      const data = response?.data?.content?.[0]
      if (!data) return
      if (type === 'requestor') {
        setValue(`person${task?.id}`, Number(data.id))
        setValue(`account${task?.id}`, null)

        setPersonRecordId(resVal?.data.id)
        setSelectedPersonEntityType(getEntityName(data.entity_type))
        setDefaultPersonOption({
          label: data.name ?? '',
          value: data.id?.toString() ?? '',
        })

        await fetchPersonOptions(
          0,
          personOptionsSize,
          data.name ?? '',
          data.id as number
        )
        setPersonUpdateKey((prev) => prev + 1)
      } else {
        setValue(`account${task?.id}`, Number(data?.id))
        setValue(`person${task?.id}`, null)

        setAccountRecordId(resVal?.data.id)
        setSelectedAccountEntityType(getEntityName(data.organization_type))
        setDefaultAccountOption({
          label: data.organization_name ?? '',
          value: data.id?.toString() ?? '',
        })

        await fetchAccountOptions(
          0,
          accountOptionsSize,
          data.organization_name ?? '',
          data.id as number
        )
        setAccountUpdateKey((prev) => prev + 1)
      }
      handleClose()
    } catch (err) {
      console.error(err)
      handleCatch()
    }
  }
  const handleSave = async (values: FieldValues, embedded: string[]) => {
    try {
      dispatch(showLoader())
      await save(values, embedded)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleEdit = () => {
    setIsEditLayoutShown(true)
  }
  const handleInvalid = (errors: FieldErrors<FieldValues>) => {
    console.error(errors)
    let requiredFilled = true

    Object.keys(errors).forEach((key) => {
      const error = errors[key]
      if (error?.type === 'required') {
        requiredFilled = false
      }
    })
    dispatch(
      addToaster({
        message: requiredFilled
          ? NAMESPACES.VALID_TOAST
          : NAMESPACES.REQUIRED_TOAST,
        type: 'error',
        id: uuid(),
      })
    )
  }

  const saveTaskEntitiesData = async (
    id: number | null,
    type: string,
    task: WorkflowInstanceTaskType | null
  ) => {
    if (task?.state !== WORKFLOW_STATUS?.COMPLETED) {
      let payload: TaskPayload
      if (type === NAMESPACES.PERSON.toLowerCase()) {
        payload = {
          id: Number(task?.id),
          requestor_view: { id: id },
          organization_view: { id: null },
        }
      } else {
        payload = {
          id: Number(task?.id),
          organization_view: { id: id },
          requestor_view: { id: null },
        }
      }
      try {
        await saveTaskDataApi(
          task?.id as string,
          payload,
          caseData?.programs?.id?.toString(),
          caseData?.services?.id?.toString()
        )
        reFetch?.()
      } catch (error) {
        console.error(error)
      }
    }
  }
  const cancelClick = () => {
    setAddEntityRecord(false)
    setEditEntityRecord(false)
    setIsViewClicked(false)
  }
  const triggerClick = () => {
    if (buttonRef.current) {
      buttonRef.current.click()
    }
  }

  const fetchEditRecordData = async (layoutId: number) => {
    try {
      dispatch(showLoader())
      const res = await getEntityData(
        entityTypeAndId?.entityType ?? '',
        Number(entityTypeAndId?.entityId),
        Number(layoutId),
        viewEntityRecord?.id.toString() ?? ''
      )
      if (res?.data) {
        setEditRecordData(res.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchViewLayout = async () => {
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: entityTypeAndId?.entityId?.toString() ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE,
        isDefault: true,
      })
      if (res?.data) {
        setViewLayout(res.data?.[0])
      }
      fetchEditRecordData(res?.data?.[0]?.id ?? 0)
    } catch (err) {
      console.error(err)
    }
  }
  const fetchEditLayout = async () => {
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: entityTypeAndId?.entityId?.toString() ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.VIEW_EDIT,
        isDefault: true,
      })
      if (res?.data) {
        setEditLayout(res.data?.[0])
      }
      fetchEditRecordData(res?.data?.[0]?.id ?? 0)
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const requestorPayload = (
    row: DataTypeStore,
    keyValue: string,
    type?: boolean
  ) => ({
    entity_name: type === true ? 'organization_view' : 'requestor_view',
    select: [
      type === true ? 'organization_name' : 'name',
      'record_id',
      'record_key',
      type === true ? 'organization_type' : 'entity_type',
    ],
    page: 0,
    size: 1,
    filters: [
      {
        criteria: [
          {
            field_name: 'record_key',
            operation: 'LIKE',
            values: [row?.[keyValue] as string],
          },
        ],
      },
    ],
  })
  const getRecordKeyByEntity = (entityName: string) => {
    if (entityName?.includes('contact')) return PERSON_RECORD_KEYS.CONTACT_KEY
    if (entityName?.includes('provider')) return PERSON_RECORD_KEYS.PROVIDER_KEY
    if (entityName?.includes('patient')) return PERSON_RECORD_KEYS.PATIENT_KEY
  }
  const getRecordKeyAndEntityTypeByEntity = (entityName: string) => {
    if (entityName?.includes('contact'))
      return { keyValue: PERSON_RECORD_KEYS.CONTACT_KEY, type: 'requestor' }
    if (entityName?.includes('provider'))
      return { keyValue: PERSON_RECORD_KEYS.PROVIDER_KEY, type: 'requestor' }
    if (entityName?.includes('patient'))
      return { keyValue: PERSON_RECORD_KEYS.PATIENT_KEY, type: 'requestor' }
    if (entityName?.includes('organization'))
      return {
        keyValue: PERSON_RECORD_KEYS.ORGANIZATION_KEY,
        type: 'organization',
      }
    if (entityName?.includes('payer'))
      return { keyValue: PERSON_RECORD_KEYS.PAYER_KEY, type: 'organization' }
    if (entityName?.includes('facilities'))
      return { keyValue: PERSON_RECORD_KEYS.FACILITY_KEY, type: 'organization' }
    if (entityName?.includes('pharmacies'))
      return { keyValue: PERSON_RECORD_KEYS.PHARMACY_KEY, type: 'organization' }
    else return { keyValue: '', type: '' }
  }
  const handleEditEntityRecord = async (
    entityType?: string,
    entityId?: number,
    layoutId?: number,
    values?: FieldValues
  ) => {
    const res = await editEntityData(
      entityType ?? '',
      Number(entityId),
      layoutId ?? 0,
      values ?? {},
      viewEntityRecord?.id?.toString() ?? ''
    )

    if (res?.data) {
      dispatch(
        addToaster({
          id: uniqueId(),
          message: TOASTER_NAMESPACE.ADD_SUCCESS,
          type: 'success',
        })
      )
      cancelClick()
      setTriggerSearch((prev) => !prev)
    }
  }

  const handleAddEntityRecord = async (
    entityType?: string,
    entityId?: number,
    layoutId?: number,
    values?: FieldValues
  ) => {
    const res = await addEntityData(
      entityType ?? '',
      Number(entityId),
      Number(layoutId),
      values ?? {}
    )

    if (!res?.data) return

    addToaster({
      id: uniqueId(),
      message: TOASTER_NAMESPACE.ADD_SUCCESS,
      type: 'success',
    })

    const keyValue = getRecordKeyByEntity(entityType ?? '')
    if (!keyValue) return

    const resVal = await getEntityDataByIdEmbedded(
      entityType ?? '',
      Number(entityId),
      [keyValue],
      res.data.id
    )

    if (!resVal?.data) return

    const response = await getEntityDataByEntityNameApiForFilter({
      payload: requestorPayload(resVal.data, keyValue),
    })

    const data = response?.data?.content?.[0]
    if (!data) return

    setValue(`person${task?.id}`, Number(data.id))
    setValue(`account${task?.id}`, null)
    setDefaultAccountOption(undefined)
    await saveTaskEntitiesData(
      Number(data.id),
      NAMESPACES.PERSON.toLowerCase(),
      task
    )

    setPersonRecordId(resVal?.data.id)
    setSelectedPersonEntityType(getEntityName(data.entity_type))
    setDefaultPersonOption({
      label: data.name ?? '',
      value: data.id?.toString() ?? '',
    })

    await fetchPersonOptions(
      0,
      personOptionsSize,
      data.name ?? '',
      data.id as number
    )

    setIsAdvancedSearch(false)
    cancelClick()
    setTriggerSearch((prev) => !prev)
  }

  const editSelectedRecordAdvanceSearh = async (values: FieldValues) => {
    try {
      dispatch(showLoader())
      const { entityType, entityId } = entityTypeAndId ?? {}
      const layoutId = editLayout?.id ?? 0

      if (editEntityRecord) {
        await handleEditEntityRecord(entityType, entityId, layoutId, values)
      } else if (addEntityRecord) {
        const flagValue = validatePhoneNumberAndAddress(values, dispatch)
        if (flagValue) {
          return
        }
        await handleAddEntityRecord(entityType, entityId, layoutId, values)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const hasEditPermission = () => {
    const hasServicePermission = permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      task,
      userId ?? ''
    )
    const hasIdentifierKey = task?.identifier?.task_permission
    if (hasIdentifierKey) {
      const hasTaskEditPermission =
        programPermissions[
          caseData?.programs?.id ?? workflowDefinition?.program_id ?? ''
        ]?.[hasIdentifierKey]?.Manage === true
      return hasTaskEditPermission
    } else {
      return hasServicePermission
    }
  }

  const isFieldDisabled = (field: string) =>
    task?.identifier?.disabled_fields?.includes(field)

  const handlePersonChange = (e: unknown | EntityEventType) => {
    const event = e as unknown as EntityEventType
    setValue(`person${task?.id}`, event?.value)
    setDefaultAccountOption(undefined)
    setValue(`account${task?.id}`, null)
    saveTaskEntitiesData(
      event?.value ? event.value : null,
      NAMESPACES.PERSON.toLowerCase(),
      task
    )
    if (event.label === '') {
      setPersonRecordId(null)
      setSelectedPersonEntityType(null)
      setSelectedEntityDropdown('')
      fetchPersonOptions(0, personOptionsSize)
      setDefaultPersonOption(undefined)
    } else {
      fetchAccountOptions(0, accountOptionsSize)
      setPersonRecordId(event?.recordId)
      setSelectedPersonEntityType(getEntityName(event?.entityType))
      setDefaultPersonOption({
        label: event?.label ?? '',
        value: event?.value?.toString() ?? '',
      })
    }
  }

  useEffect(() => {
    fetchPersonOptions(0, personOptionsSize)
    fetchAccountOptions(0, accountOptionsSize)
  }, [])

  useEffect(() => {
    if (json) {
      if (!isSuperAdmin() && Object.keys(programPermissions).length === 0)
        return
      fetchEntityData(isEditLayoutShown)
    }
  }, [programPermissions, json])
  useEffect(() => {
    if (
      !hasPersonOptionsInitialized?.current &&
      searchPersonOption?.length > 0 &&
      task
    ) {
      if (task?.requestor_view) {
        setValue(`person${task?.id}`, task?.requestor_view?.id)
        fetchPersonOptions(
          0,
          personOptionsSize,
          task?.requestor_view?.name ?? '',
          Number(task?.requestor_view?.id)
        )
        setDefaultPersonOption({
          label: task?.requestor_view?.name ?? '',
          value: task?.requestor_view?.id ?? '',
        })
        setPersonRecordId(Number(task?.requestor_view?.record_id))
        setSelectedPersonEntityType(
          getEntityName(String(task?.requestor_view?.entity_type))
        )
      }
      hasPersonOptionsInitialized.current = true
    }
  }, [searchPersonOption, task])

  useEffect(() => {
    if (
      !hasAccountOptionsInitialized?.current &&
      searchAccountOption?.length > 0 &&
      task
    ) {
      if (task?.organization_view) {
        setValue(`account${task?.id}`, task?.organization_view?.id)
        fetchAccountOptions(
          0,
          accountOptionsSize,
          task?.organization_view?.organization_name ?? '',
          Number(task?.organization_view?.id)
        )
        setDefaultAccountOption({
          label: task?.organization_view?.organization_name ?? '',
          value: task?.organization_view?.id?.toString() ?? '',
        })
        setAccountRecordId(Number(task?.organization_view?.record_id))
        setSelectedAccountEntityType(
          getEntityName(
            String(
              (task?.organization_view as OrganizationOptions)
                ?.organization_type
            )
          ) //INFO: Changed on 22/06/2024, fixed as entity was accessed incorrectly
        )
      }
      hasAccountOptionsInitialized.current = true
    }
  }, [searchAccountOption, task])
  useEffect(() => {
    if (task) {
      if (task?.outcome) {
        setValue(`outcome${task?.id}`, task.outcome)
      }
      if (task?.task_template) {
        setValue(`task_type${task?.id}`, String(task?.task_template?.name))
      }
      if (task?.entity_type_name) {
        setValue(`entity_type${task?.id}`, task?.entity_type_name)
      }
      if (task?.entity_name) {
        setValue(`entity${task?.id}`, task?.entity_name)
      }
    }
  }, [task])

  useEffect(() => {
    if (defaultEditLayout && defaultViewLayout) {
      if (isEditLayoutShown) {
        setJSON([defaultEditLayout])
      } else {
        setJSON([defaultViewLayout])
      }
    }
  }, [isEditLayoutShown, defaultEditLayout, defaultViewLayout])

  useEffect(() => {
    if (
      viewEntityRecord?.id &&
      viewEntityRecord?.requestor_id &&
      !editEntityRecord &&
      !addEntityRecord &&
      !isViewClicked
    ) {
      setValue(`person${task?.id}`, Number(viewEntityRecord?.requestor_id))
      setValue(`account${task?.id}`, null)
      setDefaultAccountOption(undefined)
      saveTaskEntitiesData(
        Number(viewEntityRecord.requestor_id),
        NAMESPACES.PERSON.toLowerCase(),
        task
      )
      if (
        (
          viewEntityRecord?.requestor_callback_data as unknown as {
            name: string
          }
        )?.name === ''
      ) {
        setPersonRecordId(null)
        setSelectedPersonEntityType(null)
        setSelectedEntityDropdown('')
        fetchPersonOptions(0, personOptionsSize)
        setDefaultPersonOption(undefined)
      } else {
        setPersonRecordId(
          (
            viewEntityRecord?.requestor_callback_data as unknown as {
              record_id: number
            }
          )?.record_id
        )
        setSelectedPersonEntityType(
          getEntityName(viewEntityRecord?.entity_type as string)
        )
        setDefaultPersonOption({
          label:
            (
              viewEntityRecord?.requestor_callback_data as unknown as {
                name: string
              }
            )?.name ?? '',
          value: viewEntityRecord?.requestor_id?.toString() ?? '',
        })
        fetchPersonOptions(
          0,
          personOptionsSize,
          (
            viewEntityRecord?.requestor_callback_data as unknown as {
              name: string
            }
          )?.name ?? '',
          viewEntityRecord?.requestor_id as number
        )
      }

      setIsAdvancedSearch(false)
    }
  }, [viewEntityRecord])
  useEffect(() => {
    if (editEntityRecord || addEntityRecord) {
      fetchEditLayout()
    }
    if (viewEntityRecord) {
      fetchViewLayout()
    }
  }, [editEntityRecord, addEntityRecord, isViewClicked])

  useEffect(() => {
    if (!isAdvancedSearch) {
      setEntityDataInner(undefined)
      setEntityTypeAndId({ entityId: 0, entityType: '', label: '' })
    }
  }, [isAdvancedSearch])

  useEffect(() => {
    const fetchAndSetAccountValue = async () => {
      if (!task?.organization_view?.id) return
      await fetchAccountOptions(
        0,
        accountOptionsSize,
        task?.organization_view?.organization_name as string,
        task?.organization_view?.id as number
      )
      if (task?.requestor_view) {
        setValue(`person${task.id}`, task.requestor_view.id)
      }
      if (task?.organization_view) {
        setValue(`account${task.id}`, task.organization_view.id)
      }
    }
    if (
      task?.identifier?.sub_ui_identifier ===
        WORKFLOW_UI_IDENTIFIER.PAP_SEND_COMMUNICATION_FAX &&
      task?.organization_view
    ) {
      setAccountUpdateKey((prev) => prev + 1)
      fetchAndSetAccountValue()
      setDefaultAccountOption({
        label: task?.organization_view?.organization_name as string,
        value: task?.organization_view?.id as string,
      })
      setSelectedAccountEntityType(
        getEntityName(
          String(
            (task?.organization_view as OrganizationOptions)?.organization_type
          )
        )
      )
      setAccountRecordId(task?.organization_view?.record_id ?? null)
    }
  }, [task?.organization_view?.id, task?.requestor_view?.id])

  return (
    <div className="flex items-center gap-4 pt-1 border-t border-t-accent-200 pb-2 bg-secondary-50">
      <div className="flex flex-1 items-center gap-2 font-primary text-xs">
        <span className="pl-2 whitespace-nowrap">{NAMESPACES.TASK_TYPE}:</span>
        <Tooltip content={watch(`task_type${task?.id}`)}>
          <div className="flex-1">
            <FormInput
              dataQaId="task_type-dropdown"
              disabled={true}
              label={''}
              name={`task_type${task?.id}`}
              register={register}
              minHeight="5"
              className="h-[0.8rem]"
            />
          </div>
        </Tooltip>
      </div>
      <div className="flex items-center justify-center px-2">
        <SvgVerticalSplitter />
      </div>
      <div className="flex flex-1 items-center gap-2 font-primary text-xs">
        <span className="whitespace-nowrap">{NAMESPACES.OUTCOME}:</span>
        <div className="flex-1">
          <ControlledDropDown
            dataQaId="outcome-dropdown"
            control={control}
            required={true}
            name={`outcome${task?.id}`}
            placeholder="Select"
            height="h-[0.8rem]"
            options={outcomeOptions}
            onChange={handleDropdownChange(NAMESPACES.OUTCOME.toLowerCase())}
            disabled={
              isTaskCompleted ||
              isFieldDisabled(NAMESPACES.OUTCOME.toLowerCase()) ||
              !hasEditPermission()
            }
            isCrossable={false}
            className="bg-accent-0"
            errors={errors}
          />
        </div>
      </div>
      <div className="flex items-center justify-center px-2">
        <SvgVerticalSplitter />
      </div>
      <div className="flex flex-1 items-center gap-2 font-primary text-xs">
        <span className="whitespace-nowrap">{NAMESPACES.PERSON}:</span>
        <div className="flex-1">
          <PaginatedControlledDropDown
            key={`${
              task?.requestor_view?.id ?? task?.organization_view?.id
            }_${personUpdateKey}`}
            dataQaId="person-dropdown"
            control={control}
            required={true}
            height="h-[0.8rem]"
            name={`person${task?.id}`}
            icon={(disabled: boolean, closeOptions: () => void) =>
              renderPersonDropdownIcon(
                disabled,
                closeOptions,
                defaultPersonOption
              )
            }
            customPadding="!px-1"
            placeholder="Select"
            options={
              searchPersonOption as unknown as DropdownType<unknown, string>[]
            }
            onChange={handlePersonChange}
            page={personOptionsCurrentPage}
            limit={personOptionsSize}
            fetchOptions={fetchPersonOptions}
            virtualScroll={true}
            isCrossable={true}
            className="bg-accent-0"
            errors={errors}
            disabled={
              isTaskCompleted ||
              isFieldDisabled(NAMESPACES.PERSON.toLowerCase()) ||
              !hasEditPermission() ||
              !!isAccountDisabled
            }
            defaultValue={task?.requestor_view?.id as string}
          />
        </div>
      </div>
      <div className="flex items-center justify-center px-2">
        <SvgVerticalSplitter />
      </div>
      <div className="flex flex-1 items-center gap-2 font-primary text-xs">
        <span className="whitespace-nowrap">{NAMESPACES.ACCOUNT}:</span>
        <div className="flex-1 pr-2">
          {isAccountDisabled ? (
            <div className="border border-gray-300  rounded-md bg-[#f6f6f6] h-[1.8rem]" />
          ) : (
            <PaginatedControlledDropDown
              dataQaId="account-dropdown"
              customPadding="!px-1"
              control={control}
              required={true}
              height="h-[0.8rem]"
              name={`account${task?.id}`}
              placeholder="Select"
              options={
                searchAccountOption as unknown as DropdownType<
                  unknown,
                  string
                >[]
              }
              {...(defaultAccountOption
                ? {
                    icon: (disabled, closeOptions) =>
                      renderAccountDropdownIcon(
                        disabled,
                        closeOptions,
                        defaultAccountOption
                      ),
                  }
                : {})}
              onChange={(e) => {
                const event = e as unknown as EntityEventType
                setValue(`account${task?.id}`, event?.value)
                setValue(`person${task?.id}`, null)
                setDefaultPersonOption(undefined)
                saveTaskEntitiesData(
                  event?.value ? event.value : null,
                  NAMESPACES.ACCOUNT.toLowerCase(),
                  task
                )
                if (event.label === '') {
                  setAccountRecordId(null)
                  setSelectedAccountEntityType(null)
                  setSelectedEntityDropdown('')
                  fetchAccountOptions(0, accountOptionsSize)
                  setDefaultAccountOption(undefined)
                } else {
                  fetchPersonOptions(0, personOptionsSize)
                  setAccountRecordId(event?.recordId)
                  setSelectedAccountEntityType(getEntityName(event?.entityType))
                  setDefaultAccountOption({
                    label: event?.label ?? '',
                    value: event?.value?.toString() ?? '',
                  })
                }
              }}
              fetchOptions={fetchAccountOptions}
              virtualScroll={true}
              isCrossable={true}
              className="bg-accent-0"
              errors={errors}
              page={accountOptionsCurrentPage}
              limit={accountOptionsSize}
              key={`${watch(`person${task?.id}`)}_${accountUpdateKey}_${
                task?.organization_view?.id ?? task?.requestor_view?.id
              }`}
              disabled={
                isTaskCompleted ||
                isFieldDisabled(NAMESPACES.ACCOUNT.toLowerCase()) ||
                !hasEditPermission()
              }
              defaultValue={task?.organization_view?.id as string}
            />
          )}
        </div>
      </div>
      {isAdvancedSearch && (
        <AddDataModal>
          <div>
            <Modal
              isOpen={isAdvancedSearch}
              closeModal={() => {
                setIsAdvancedSearch(false)
                setEditEntityRecord(false)
                setAddEntityRecord(false)
                setEntityTypeAndId({
                  entityId: 0,
                  entityType: '',
                  label: '',
                })
                setEntityDataInner(undefined)
              }}
              showCloseButton={false}
              width="min-w-[50vw] max-w-[50vw] max-h-[55vh]"
              isDragable
            >
              {editEntityRecord ? (
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <div>
                      <span
                        className="font-medium text-base font-primary cursor-pointer"
                        onClick={cancelClick}
                      >
                        {APPLICATION_PREFERENCES_STRINGS?.ADVANCED_SEARCH}{' '}
                      </span>
                      <span
                        className={`font-medium text-base font-primary cursor-pointer ${
                          viewEntityRecord || addEntityRecord
                            ? 'text-primary-500'
                            : ''
                        }`}
                      >
                        {`/ ${
                          editEntityRecord
                            ? NAMESPACES.EDIT
                            : addEntityRecord
                            ? NAMESPACES.ADD
                            : NAMESPACES.VIEW
                        } ${entityTypeAndId?.label}`}
                      </span>
                    </div>
                    <div className="flex gap-2">
                      <CustomButton onClick={cancelClick}>
                        {APPLICATION_PREFERENCES_STRINGS?.CANCEL}
                      </CustomButton>
                      <CustomButton isFilled onClick={triggerClick}>
                        {APPLICATION_PREFERENCES_STRINGS?.UPDATE}
                      </CustomButton>
                    </div>
                  </div>
                  <FormRenderer
                    heading={
                      <>
                        <button
                          ref={buttonRef}
                          type="submit"
                          className="cursor-pointer pr-[6px] hidden"
                        />
                      </>
                    }
                    layout={editLayout?.layout_data as LayoutData}
                    mode={MODE_CONSTANTS?.EDIT}
                    data={editRecordData}
                    handleFormSubmit={editSelectedRecordAdvanceSearh}
                    fullLayout={editLayout as EntityLayout}
                  />
                </div>
              ) : null}
              {addEntityRecord ? (
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <div>
                      <span
                        className="font-medium text-base font-primary cursor-pointer"
                        onClick={cancelClick}
                      >
                        {APPLICATION_PREFERENCES_STRINGS?.ADVANCED_SEARCH}{' '}
                      </span>
                      <span
                        className={`font-medium text-base font-primary cursor-pointer ${
                          viewEntityRecord || addEntityRecord
                            ? 'text-primary-500'
                            : ''
                        }`}
                      >
                        {`/ ${
                          editEntityRecord
                            ? NAMESPACES.EDIT
                            : addEntityRecord
                            ? NAMESPACES.ADD
                            : NAMESPACES.VIEW
                        } ${entityTypeAndId?.label}`}
                      </span>
                    </div>
                    <div className="flex gap-2">
                      <CustomButton onClick={cancelClick}>
                        {APPLICATION_PREFERENCES_STRINGS?.CANCEL}
                      </CustomButton>
                      <CustomButton isFilled onClick={triggerClick}>
                        {APPLICATION_PREFERENCES_STRINGS?.SUBMIT}
                      </CustomButton>
                    </div>
                  </div>
                  <FormRenderer
                    heading={
                      <>
                        <button
                          ref={buttonRef}
                          type="submit"
                          className="cursor-pointer pr-[6px] hidden"
                        />
                      </>
                    }
                    layout={editLayout?.layout_data as LayoutData}
                    mode={MODE_CONSTANTS?.ADD}
                    handleFormSubmit={editSelectedRecordAdvanceSearh}
                    fullLayout={editLayout as EntityLayout}
                  />
                </div>
              ) : null}
              {isViewClicked ? (
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <div>
                      <span
                        className="font-medium text-base font-primary cursor-pointer"
                        onClick={cancelClick}
                      >
                        {APPLICATION_PREFERENCES_STRINGS?.ADVANCED_SEARCH}{' '}
                      </span>
                      <span
                        className={`font-medium text-base font-primary cursor-pointer ${
                          viewEntityRecord || addEntityRecord
                            ? 'text-primary-500'
                            : ''
                        }`}
                      >
                        {`/ ${
                          editEntityRecord
                            ? NAMESPACES.EDIT
                            : addEntityRecord
                            ? NAMESPACES.ADD
                            : NAMESPACES.VIEW
                        } ${entityTypeAndId?.label}`}
                      </span>
                    </div>
                    <div className="flex gap-2">
                      <CustomButton onClick={cancelClick}>
                        {APPLICATION_PREFERENCES_STRINGS?.CANCEL}
                      </CustomButton>
                      <CustomButton
                        isFilled
                        onClick={() => {
                          setValue(
                            `person${task?.id}`,
                            Number(viewEntityRecord?.requestor_id)
                          )
                          setValue(`account${task?.id}`, null)
                          setDefaultAccountOption(undefined)
                          saveTaskEntitiesData(
                            Number(viewEntityRecord?.requestor_id),
                            NAMESPACES.PERSON.toLowerCase(),
                            task
                          )
                          if (
                            (
                              viewEntityRecord?.requestor_callback_data as unknown as {
                                name: string
                              }
                            )?.name === ''
                          ) {
                            setPersonRecordId(null)
                            setSelectedPersonEntityType(null)
                            setSelectedEntityDropdown('')
                            fetchPersonOptions(0, personOptionsSize)
                            setDefaultPersonOption(undefined)
                          } else {
                            setPersonRecordId(
                              (
                                viewEntityRecord?.requestor_callback_data as unknown as {
                                  record_id: number
                                }
                              )?.record_id
                            )
                            setSelectedPersonEntityType(
                              getEntityName(
                                viewEntityRecord?.entity_type as string
                              )
                            )
                            setDefaultPersonOption({
                              label:
                                (
                                  viewEntityRecord?.requestor_callback_data as unknown as {
                                    name: string
                                  }
                                )?.name ?? '',
                              value:
                                viewEntityRecord?.requestor_id?.toString() ??
                                '',
                            })
                            fetchPersonOptions(
                              0,
                              personOptionsSize,
                              (
                                viewEntityRecord?.requestor_callback_data as unknown as {
                                  name: string
                                }
                              )?.name ?? '',
                              viewEntityRecord?.requestor_id as number
                            )
                          }

                          cancelClick()
                          setIsAdvancedSearch(false)
                        }}
                      >
                        {APPLICATION_PREFERENCES_STRINGS?.SELECT}
                      </CustomButton>
                    </div>
                  </div>
                  <FormRenderer
                    heading={
                      <>
                        <button
                          ref={buttonRef}
                          type="submit"
                          className="cursor-pointer pr-[6px] hidden"
                        />
                      </>
                    }
                    layout={viewLayout?.layout_data as LayoutData}
                    mode={MODE_CONSTANTS?.VIEW}
                    data={editRecordData}
                    handleFormSubmit={editSelectedRecordAdvanceSearh}
                    fullLayout={viewLayout as EntityLayout}
                  />
                </div>
              ) : null}
              <div
                className={`${
                  editEntityRecord || addEntityRecord || isViewClicked
                    ? 'hidden'
                    : ''
                }`}
              >
                <div className="flex justify-between items-center mb-2">
                  <span className="font-medium text-base font-primary">
                    {APPLICATION_PREFERENCES_STRINGS?.ADVANCED_SEARCH}
                  </span>
                  <CustomButton
                    onClick={() => {
                      setIsAdvancedSearch(false)
                      setEditEntityRecord(false)
                      setAddEntityRecord(false)
                      setEntityTypeAndId({
                        entityId: 0,
                        entityType: '',
                        label: '',
                      })
                      setEntityDataInner(undefined)
                    }}
                  >
                    {APPLICATION_PREFERENCES_STRINGS?.CANCEL}
                  </CustomButton>
                </div>
                <Accordion
                  heading={'Search  Requestor Information'}
                  isDefaultActive={true}
                >
                  <div className="flex flex-col gap-y-4 p-3">
                    <div className="grid gap-x-3 gap-y-4 grid-cols-3">
                      <SelectDropDown
                        label={'Entity Type'}
                        options={entityOptions}
                        onChange={handleEntityChange}
                        name=""
                        required
                        dataQaId={`requestor-entity-${'right'}`}
                        isSearchable
                        defaultValue={entityDataInner?.value ?? ''}
                      />
                    </div>
                    {entityTypeAndId?.entityType && (
                      <SearchLayout
                        entity_id={
                          entityTypeAndId?.entityType?.toLowerCase() ===
                          'organization'
                            ? ORGANIZATION_ENTITY.value
                            : entityTypeAndId?.entityId?.toString() ?? ''
                        }
                        entity_name={
                          entityTypeAndId?.entityType?.toLowerCase() ===
                          'organization'
                            ? ORGANIZATION_ENTITY.label
                            : entityTypeAndId?.entityType
                                ?.toString()
                                ?.replace('c_', '')
                                ?.replace(/^./, (char) => char.toUpperCase())
                                ?.replace(/s$/, '') ?? ''
                        }
                        organizationType={undefined}
                        setViewEntityRecord={setViewEntityRecord}
                        viewEntityRecord={viewEntityRecord}
                        advancedFiltersData={advancedFiltersData}
                        setAdvancedFiltersData={setAdvancedFiltersData}
                        setEditEntityRecord={setEditEntityRecord}
                        setAddEntityRecord={setAddEntityRecord}
                        setIsViewClicked={setIsViewClicked}
                        isLookup={true}
                        triggerSearch={triggerSearch}
                        fromTask
                        key={entityTypeAndId?.entityType}
                      />
                    )}
                  </div>
                </Accordion>
              </div>
            </Modal>
          </div>
        </AddDataModal>
      )}
      {isOpenModal && json?.length && (
        <Modal
          width="w-[70rem] h-[35rem]"
          isOpen={isOpenModal}
          closeModal={handleClose}
        >
          <div className="p-4">
            <FormRenderer
              mode={isEditLayoutShown ? 'edit' : 'view'}
              heading={
                <div className="pb-2 flex justify-between items-center w-full border-b-2">
                  <div className="w-full">
                    <FormHeader
                      mode={isEditLayoutShown ? 'edit' : 'view'}
                      data={json as unknown as EntityLayout[]}
                      headerLabel=""
                      shouldModalOpen={true}
                      enableAuditButton={false}
                      allowNavigate={false}
                      entityId={selectedEntityId ?? ''}
                      isAttachCase={false}
                      id={undefined}
                      isFormDirty={true}
                      showButtonsInView={true}
                      showFooter={isEditLayoutShown}
                      showDraftInEdit={
                        entityData?.['record_status'] === RECORD_STATUS.DRAFT
                      }
                      showDraftInAdd={false}
                      showEditInView={
                        !isEditLayoutShown &&
                        (!entityData?.is_client_controlled ||
                          hasSensitiveDataPermission())
                      }
                      onCancel={handleClose}
                      onAttachClick={noop}
                      onEditClick={handleEdit}
                      isBorderBottom={false}
                    />
                  </div>
                  {isEditLayoutShown && (
                    <div className="ml-auto">
                      <DefaultFormFooter
                        mode={isEditLayoutShown ? 'edit' : 'add'}
                        isFormDirty={true}
                        shouldModalOpen={false}
                        data={json as unknown as EntityLayout[]}
                        headerLabel=""
                        enableAuditButton={false}
                        allowNavigate={false}
                        entityId={selectedEntityId ?? ''}
                        isEdit={false}
                        id={undefined}
                        onCancel={() => setIsEditLayoutShown(false)}
                        onEditClick={noop}
                      />
                    </div>
                  )}
                </div>
              }
              layout={
                (json as unknown as EntityLayout[])?.[0]
                  ?.layout_data as unknown as LayoutData
              }
              fullLayout={
                (
                  json as unknown as EntityLayout[]
                )?.[0] as unknown as EntityLayout
              }
              handleFormSubmit={(values: FieldValues, embedded: string[]) => {
                handleSave(
                  { ...values, record_status: RECORD_STATUS.ACTIVE },
                  embedded
                )
              }}
              data={entityData}
              handleFormInvalid={handleInvalid}
            />
          </div>
        </Modal>
      )}
    </div>
  )
}

export default TaskManagementDropdownSection
